// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_option from "../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as FormInput$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/FormInput.mjs";
import * as FormDateInputV2$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/form-input/date-time/deprecated/FormDateInputV2.mjs";
import * as PnMHelper$PorterinFeature from "../../../containers/pnm/domain/helper/PnMHelper.mjs";
import * as PnMStoreEn$PorterinFeature from "../../../containers/pnm/domain/store/PnMStoreEn.mjs";
import * as LeadFormDatePickerModuleScss from "./styles/LeadFormDatePicker.module.scss";

var styles = LeadFormDatePickerModuleScss;

function LeadFormDatePickerCmp(Props) {
  var form = Props.form;
  return React.createElement(FormDateInputV2$Catalyst.make, {
              input_props: FormInput$Catalyst.make_props("", (function (param) {
                      
                    }), form.submitting, undefined, undefined, undefined, undefined, undefined, form.dateResult, undefined, styles["date-input-wrapper"], undefined, undefined, undefined, undefined, undefined, undefined, undefined),
              date_props: FormDateInputV2$Catalyst.make_props(Caml_option.some(Caml_option.some(form.input.date)), Caml_option.some(Caml_option.some(PnMHelper$PorterinFeature.getMinDate(undefined))), Caml_option.some(Caml_option.some(PnMHelper$PorterinFeature.getMaxDate(undefined))), (function (date) {
                      Curry._2(form.updateDate, (function (input, date) {
                              return {
                                      pickup: input.pickup,
                                      drop: input.drop,
                                      date: date,
                                      name: input.name,
                                      mobile: input.mobile,
                                      house: input.house,
                                      show_house_field: input.show_house_field
                                    };
                            }), date);
                    }), undefined, "standard", undefined, undefined, undefined, styles["date-picker"], PnMStoreEn$PorterinFeature.date_format, undefined, undefined)
            });
}

var make = LeadFormDatePickerCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
